import { isPresent } from '../utils';
// tslint:enable:max-line-length
/**
 * @hidden
 * Type guard for `CompositeFilterDescriptor`.
 */
export var isCompositeFilterDescriptor = function (source) {
    return isPresent(source.filters);
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-data-query/dist/es/filtering/filter-descriptor.interface.js
// module id = 112
// module chunks = 0